import designPointRules from '../../config/energy-efficiency-rules.json';

type RuleConditionValue = string | string[];

type DesignPointRule = {
  when: Record<string, RuleConditionValue>;
  points: number;
};

type DesignPointRuleSet = {
  version: string;
  categories: Record<string, DesignPointRule[]>;
};

export class DesignPointsService {
  private static readonly rules: DesignPointRuleSet =
    designPointRules as DesignPointRuleSet;

  static calculateDesignPoints(choices: DesignChoices): number {
    return Object.values(this.rules.categories)
      .map((rules) => this.getPointsForCategory(rules, choices))
      .reduce((total, points) => total + points, 0);
  }

  private static getPointsForCategory(
    rules: DesignPointRule[],
    choices: DesignChoices,
  ): number {
    const matchingRule = rules.find((rule) =>
      this.isRuleMatch(rule.when, choices),
    );
    return matchingRule?.points ?? 0;
  }

  private static isRuleMatch(
    conditions: Record<string, RuleConditionValue>,
    choices: DesignChoices,
  ): boolean {
    return Object.entries(conditions).every(([key, expected]) => {
      const actual = choices[key as keyof DesignChoices];
      if (Array.isArray(expected)) {
        return expected.includes(actual);
      }
      return expected === actual;
    });
  }
}

export type DesignChoices = {
  climateZone: '1' | '2' | '3';
  primarySpaceHeatingCooling: string;
  envelope: string;
  lighting: string;
  appliances: string;
  estarClothesWasher: string;
  bathroomWaterFixtures: string;
  waterHeating: string;
};
